module.exports = __webpack_public_path__ + "img/23_37.6c5a5fde.png";